module.exports = __webpack_public_path__ + "static/media/AML Widget.2f0fdb19.svg";